<script setup>
const route = useRoute()

</script>

<template>
  <component :is="route.meta.layout" />
</template>
